<template>
  <div class="card flex flex-col lg:flex-row">
    <div class="card-top min-w-[400px]">
      <b-skeleton-img
        height="285px"
        no-aspect
      />
    </div>
    <div class="card-body lightest-gray-bg w-full">
      <div class="hotel-info flex justify-start items-center">
        <div class="p-0 m-0 w-full">
          <b-skeleton width="100%" />
        </div>
      </div>
      <div class="price-and-button flex justify-between items-end">
        <div class="price-info" />
        <div class="book-btn">
          <b-skeleton width="100px" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-top {
  position: relative;
}

.card-body {
  padding: 1.3rem 1.7rem;
}

.price-and-button {
  margin-top: 14px;
}

.price-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
